require('./bootstrap');
window.Vue = require('vue').default;
Vue.component('order-fiber', require('./components/OrderFiber.vue').default);
Vue.component('order-voip', require('./components/OrderVoip.vue').default);
Vue.component('admin-offer', require('./components/AdminOffer.vue').default);

Vue.filter('currency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

import swal from 'sweetalert2'
window.swal = swal

const vueApp = new Vue({
    el: '#app',
    data: {
        selectedProduct: null
    }
});
window.vueApp = vueApp

$(document).ready(function() {
    $('.select2').select2();
    $('.community-price-select').on('change', function() {
        var val = $(this).val();
        if(val) {
            window.location.href = window.location.pathname+'?c='+val+'#products'
        } else {
            window.location.href = window.location.pathname+'#products'
        }
    })
})
